<template>
  <div class="salon-settings">
    <div class="page-header">
      <h2>⚙️ تنظیمات سالن</h2>
      <p class="subtitle">مدیریت اطلاعات بانکی، بیعانه و تراکنش‌های مالی</p>
    </div>

    <!-- ===== تب‌ها ===== -->
    <div class="tabs">
      <button
          v-for="tab in tabs"
          :key="tab.key"
          class="tab-btn"
          :class="{ active: activeTab === tab.key }"
          @click="activeTab = tab.key"
      >
        {{ tab.icon }} {{ tab.label }}
      </button>
    </div>

    <!-- ===== محتوای تب‌ها ===== -->
    <div class="tab-content">
      <!-- تب ۱: اطلاعات بانکی -->
      <div v-if="activeTab === 'bank'" class="tab-panel">
        <BankAccount />
      </div>

      <!-- تب ۲: تنظیمات بیعانه -->
      <div v-if="activeTab === 'deposit'" class="tab-panel">
        <DepositSettings />
      </div>

    </div>
  </div>
</template>

<script>
import BankAccount from './BankAccount.vue';
import DepositSettings from './DepositSettings.vue';

export default {
  name: 'SalonSettings',

  components: {
    BankAccount,
    DepositSettings,

  },

  data() {
    return {
      activeTab: 'bank',
      tabs: [
        { key: 'bank', label: 'اطلاعات بانکی', icon: '🏦' },
        { key: 'deposit', label: 'تنظیمات بیعانه', icon: '💰' },

      ]
    };
  }
};
</script>

<style scoped>
/* ========================================== */
/* استایل‌های اصلی */
/* ========================================== */
.salon-settings {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  direction: rtl;
}

/* ========================================== */
/* هدر */
/* ========================================== */
.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
}

.page-header .subtitle {
  margin: 4px 0 0 0;
  color: #909399;
  font-size: 14px;
}

/* ========================================== */
/* تب‌ها */
/* ========================================== */
.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  background: #f5f7fa;
  padding: 6px;
  border-radius: 10px;
  margin-bottom: 24px;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s;
  font-weight: 500;
}

.tab-btn:hover {
  background: #e8f0fe;
}

.tab-btn.active {
  background: white;
  color: #409eff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* ========================================== */
/* محتوای تب‌ها */
/* ========================================== */
.tab-content {
  min-height: 400px;
}

.tab-panel {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ========================================== */
/* ریسپانسیو */
/* ========================================== */
@media (max-width: 768px) {
  .salon-settings {
    padding: 12px;
  }

  .tabs {
    flex-direction: column;
    gap: 4px;
  }

  .tab-btn {
    width: 100%;
    text-align: center;
  }

  .page-header h2 {
    font-size: 20px;
  }
}
</style>